module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"dk":{"acquiredAt":"Gennemført d.","duration":"Varighed","chooseDuration":"Vælg varighed","users":"Brugere","selectUsers":"Vælg brugere"}}')
  delete Component.options._Ctor
}
